var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{staticClass:"issues-list height-100"},[(_vm.issues?.length > 0)?_vm._l((_vm.issues),function(issue){return _c('IssueCard',{key:issue.id,staticClass:"height-100 mb-3",attrs:{"issue":issue}})}):(!_vm.isLoading)?[_c('h3',{staticClass:"reg empty-container flex-centerize"},[_vm._v("Nothing to see here")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }